import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Company } from 'src/app/domains/companies/models/company.model';
import { ConnectionEquipment, ConnectionEquipmentDetails, ConnectionEquipmentInfo } from 'src/app/domains/connectivity/models/connectivity.model';
import { ConnectivityService } from 'src/app/domains/connectivity/services/connectivity.service';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';

@Component({
  selector: 'gdp-edit-connectivity-equipment-popup',
  templateUrl: './edit-connectivity-equipment-popup.component.html',
  styleUrls: ['./edit-connectivity-equipment-popup.component.scss']
})
export class EditConnectivityEquipmentPopupComponent implements OnInit {
  public equipmentInfo: ConnectionEquipment;
  public equipmentInfoDetails: ConnectionEquipmentDetails;
  public connectionId: number
  public company: Company;
  public loading = {
    equipmentInfoDetails: false,
    submit: false
  };
  @Output() onEditEquipment: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private activeModal: NgbActiveModal,
    private connectivityService: ConnectivityService,
    private notification: NotificationService
  ) { }

  ngOnInit(): void {
    this.getEquipmentDetails();
  }

  private getEquipmentDetails(): void {
    this.loading.equipmentInfoDetails = true;
    this.connectivityService.getEquipmentDetails(this.equipmentInfo.id)
      .subscribe((res: ConnectionEquipmentDetails) => {
        this.equipmentInfoDetails = res;
        this.loading.equipmentInfoDetails = false;
      }, () => {
        this.loading.equipmentInfoDetails = false;
      });
  }

  public editReview(event) {
    this.loading.submit = true;
    this.connectivityService.updateEquipment(this.equipmentInfo.id, event)
      .subscribe(
        (response: ConnectionEquipmentInfo) => {
          this.onEditEquipment.emit();
          this.loading.submit = false;
          this.close();
        },
        (err) => {
          if (err.status === 400) {
            this.notification.error('company.connectivity.details.equipment.notifications.error.updated');
          } else {
            this.notification.error('common.errors.oops');
          }
          this.close();
        });
  }


  close() {
    this.activeModal.close();
  }

}
